import SentrySingleton from "@/singletons/sentry-singleton";

export default class WebglCompatibilityService {
    static isWebGLAvailable() {
        try {
            const canvas = document.createElement('canvas');
            return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));

        } catch (e) {
            SentrySingleton.instance.captureMessage("wegGL is not available")
            return false;
        }
    }

    static isWebGL2Available() {
        try {
            const canvas = document.createElement('canvas');
            return !!(window.WebGL2RenderingContext && canvas.getContext('webgl2'));

        } catch (e) {
            SentrySingleton.instance.captureMessage("wegGL2 is not available")
            return false;
        }
    }
}